<template>
  <div class="vx-col" v-if="showPopup">
	<div>
		<div class="vx-row w-full">
			<div class="vx-col  w-full mx-auto">
				<div class="mt-4">
					<label for="" class="vs-select--label">Service à commander*</label>
					<div class="flex w-full">
						<vs-select
							v-model="order.product_id"
							:style="styleValidator('product_id')"
							class="w-full select-large"
							@change="validateOne(order.product_id, 'product_id')"
							autocomplete
							id="select-control-width"
						>
						<vs-select-item
						:name="Math.random()"
							:key="index"
							:value="item.id"
							:text="productOptions[0].category_name == missionCategories[item.category - 1] ? missionCategories[item.category - 1] + ' - ' + item.perform : 'Autre - ' + item.perform"
							v-for="(item, index) in productOptions.filter(p => p.deliverable == 1)"
							class="w-full"
						/>
						</vs-select>
						<vx-tooltip v-if="validators['product_id'] && validators['product_id'].errText !== ''" :text="errText('product_id')" class="ml-3" style="display: inline-block;">
							<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
			</div>
			<div class="vx-col  w-full mb-2 mt-3 mx-auto">
				<label for="" class="vs-select--label">Brief</label>
				<vs-input class="w-full" v-model="order.brief_text" />
			</div>
		</div>
		</div>
		<!-- Content Addtional INfo -->
		<div v-if = "isContent">
		<div class="flex pr-5 pt-3">
			<div class="w-1/3 small-field" >
				<div>
				<label for="" class="vs-select--label">Nb. Mots *</label>
			  <div style="display: flex;">
				  <vs-input
					  class="w-full"
					  v-model="order.num_words"
					  type="number"
					  :style="styleValidator('num_words')"
					  @change="validateOne(order.num_words, 'num_words')"
				  />
				  <vx-tooltip v-if="validators['meeting_number'] && validators['meeting_number'].errText !== ''" :text="errText('meeting_number')" class="ml-3" style="display: inline-block;">
					  <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				  </vx-tooltip>
			  </div>
				</div>
			</div>
			<div class="w-1/3 small-field" >
				<div>
					<label for="" class="vs-select--label">Langue *</label>
			  <div class="flex w-full">
				  <vs-select
				  	 :name="Math.random()"
					  v-model="order.language"
					  :style="styleValidator('language')"
					  class="w-full select-large"
					  @change="validateOne(order.language, 'language')"
					  autocomplete
					  defa
					  id="select-control-width"
					  
				  >
				  <vs-select-item
					  :key="index"
					  :value="item.id"
					  :text="item.name"
					  v-for="(item, index) in redacLang"
					  class="w-full"
				  />
				  </vs-select>
			  </div>
				</div>
			</div>
			<div class="w-1/3 small-field" >
				<div>
					<label for="" class="vs-select--label">Complexité *</label>
					<div class="flex w-full">
						<vs-select
							:name="Math.random()"
							v-model="order.difficulty"
							:style="styleValidator('language')"
							class="w-full select-large"
							@change="validateOne(order.language, 'language')"
							autocomplete
							defa
							id="select-control-width"
							
						>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.name"
							v-for="(item, index) in levelList"
							class="w-full"
						/>
						</vs-select>
					</div>

				</div>
			</div>
			</div>
		</div>
		<!-- Content Addtional INfo -->
		<div class="flex pr-5 pt-3">
			<div class="w-1/3 small-field" >
				<div>
					<label for="" class="vs-select--label">Facturable au client*</label>
					<vs-select
						autocomplete
						v-model="order.billable"
						class="w-full select-large"
					>
						<vs-select-item
							:key="index"
							:value="item.value"
							:text="item.text"
							v-for="(item, index) in billableOptions"
							class="w-full"
						/>
					</vs-select>
				</div>
			</div>
			<div class="w-1/3 small-field" >
				<!-- Price -->
				<label for="" class="vs-select--label">Budget*</label>
				<div style="display: flex;">
					<vs-input
						class="w-full"
						v-model="order.budget"
						:style="styleValidator('budget')"
						@change="validateOne(order.budget, 'budget')"
					/>
					<vx-tooltip v-if="validators['budget'] && validators['budget'].errText !== ''" :text="errText('budget')" class="ml-3" style="display: inline-block;">
						<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
					</vx-tooltip>
				</div>
				<!-- /Price -->
			</div>
			<div v-if="order.billable == 1" class="w-1/3 small-field"  >
				<div>
					<label for="" class="vs-select--label">Prix de vente HT*</label>
					<div style="display: flex;">
						<vs-input class="w-full" v-model="order.billable_price" :style="styleValidator('billable_price')" @change="validateOne(order.billable_price, 'billable_price')" />
						<vx-tooltip v-if="validators['billable_price'] && validators['billable_price'].errText !== ''" :text="errText('billable_price')" class="ml-3" style="display: inline-block;">
							<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
			</div>
			<!--Consulatan --->
					<div class="w-1/3 small-field" >

					<label for="" class="vs-select--label">Consultant Rankwell</label>
					<vs-select
						v-model="order.account_manager_id"
						class="w-full select-medium mr-2"
						autocomplete
					>
						<vs-select-item
						:key="index"
						:value="item.id"
						:text="item.firstname + ' ' + item.lastname"
						v-for="(item, index) in accountmanagerOptions"
						class="w-full"
						/>
					</vs-select>
		</div>

			<div class="w-1/3 small-field" >
				<!-- Price -->
				<label for="" class="vs-select--label">Période livraison souhaitée*</label>
				<div style="display: flex;">
					<vx-input-group
						class="w-full bottom"
					>
						<flat-pickr
							class="w-full"
							v-model="order.period"
							:config="configPeriodPicker"
							:style="styleValidator('period')"
							@input="validateOne(order.period, 'period')"
						/>
					</vx-input-group>
					<vx-tooltip v-if="validators['period'] && validators['period'].errText !== ''" :text="errText('period')" class="ml-3" style="display: inline-block;">
						<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
					</vx-tooltip>
				</div>
				<!-- /Price -->
			</div>


		</div>
		<div class="flex pr-5 pt-3">
			<div class="w-2/3 small-field" >
				<label for="" class="vs-select--label">Lien Document</label>
				<vs-input class="inputx w-full"
				v-model="docLink"
				@change="validateOne(docLink, 'docLink')"
				:style="styleValidator('docLink')"/>
					<vx-tooltip v-if="validators['docLink'] && validators['docLink'].errText !== ''" :text="errText('docLink')" class="ml-3" style="display: inline-block;">
						<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
					</vx-tooltip>
			</div>
		<div class="w-1/3 small-field" >
			<label for="" class="vs-select--label">Type du document</label>
                <vs-select
                    v-model="docType"
                    class="select-medium mr-2 w-full"
                    autocomplete
                >
                <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.type_name"
                    v-for="(item, index) in typeList"
                    class="w-full"
                />
                </vs-select>
            </div>
		<div class="w-1/3 small-field" >
			<label for="" class="vs-select--label">Nom du document</label>
                <vs-input
                    class="inputx w-full"
                    v-model="docName"
					@change="validateOne(docName, 'docName')"
				:style="styleValidator('docName')"/>
					<vx-tooltip v-if="validators['docName'] && validators['docName'].errText !== ''" :text="errText('docName')" class="ml-3" style="display: inline-block;">
						<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
					</vx-tooltip>
			</div>
		</div>


		<div class="vx-row float-right mt-4">
			<div class="vx-col w-full">
				<vs-button v-if="!isFromPopup"
					color="danger"
					class="mb-2 mr-3"
					@click="closeForm()"
				>Annuler</vs-button>
				<vs-button class="mb-2" @click="formSubmitted">Valider</vs-button>
			</div>
		</div>


	</div>
  </div>
</template>

<script>
import VueCookies from "vue-cookies";
import moment from "moment";
import Order from "@/entities/Order";
import Product from "@/entities/Product";
import Validator from "@/entities/Validator";
import { ContractUser } from "@/entities/ContractUser";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import VxTooltip from "../../widgets/vx-tooltip/VxTooltip.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import store from "@/store/store";
export default {
	name: "Order",
	mixins: [dbFieldConvertor, utilsMixin],
	props: {
		contract: Object,
		show: Boolean,
		apiUrl: String,
		router: Object,
		isFromPopup: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		// Order,
		VxTooltip,
		flatPickr,
	},
	data() {
		return {
			showPopup: this.$props.show,
			order: Order.getFormFields(),
			contractUser: new ContractUser(),
			product: Product.getFormFields(),
			deliveryId: this.$props.contract.delivery, // Doit être le même que le type du contrat
			accountmanagerOptions: [],
			products: [],
			productOptions: [],
			isContent: false,
			categoryOptions: Product.getProductCategories(),
			levelList: [
				{ id: 1, name: "Standard" },
				{ id: 2, name: "Medium" },
				{ id: 3, name: "Premium" },
			],
			billableOptions: [
				{ text: "Non", value: 0 },
				{ text: "Oui", value: 1 },
			],
			docLink: null,
			docName: "",
			docType: 1,

			statusOptions: [
				{ text: "À faire", value: 1 },
				// {text: "En cours", value: 2},
				{ text: "Fait", value: 2 },
				{ text: "Annulé", value: 3 },
				{ text: "Terminée", value: 4 },
			],
			isPopupActive: false,
			validators: {
				perform: {
					errText: "",
				},
				longDescription: {
					errText: "",
				},
				shortDescription: {
					errText: "",
				},
				price: {
					errText: "",
				},
				status: {
					valid: true,
					notValid: false,
					errText: "",
				},
			},

			accountmanagerList: [],
			check: true,
			missionCategories: [],
			configPeriodPicker: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light",
					}),
				],
			},
		};
	},
	computed: {
		typeList: () => {
			return store.state.docTypeList;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		redacLang: () => {
			return store.state.redac_lang;
		},
	},
	created() {
		this.getAllProducts();
		this.getAllProductsCategories();
		this.getAllAccountManager();
		this.getAllProductForCategory();
		store.dispatch("getRedacLang");
		this.order.billable_price = null;
	},
	mounted() {
		//console.log("cntract", this.$props.contract);
		//console.log(this.$props.contract.delivery);
		//console.log(this.$props.isFromPopup);
	},
	watch: {
		"order.product_id": function (val) {
			console.log("product_id", val);
		},
		deliveryId: function () {
			this.getAllProductForCategory();
		},
	},
	methods: {
		/**
		 * Query our API to fetch all product for a category
		 */
		getAllProductForCategory() {
			if (!this.deliveryId) {
				this.deliveryId = "1";
			}
			this.product.category = this.deliveryId - 1;
			//console.log(this.deliveryId.toString());
			this.$http
				.get(this.$props.apiUrl + "product/all/" + this.deliveryId.toString())
				.then((res) => {
					//console.log(res);
					this.productOptions = res.data;

					let cat = res.data[0].category_name;

					if (this.deliveryId == 7) {
						this.productOptions = this.productOptions.filter(
							(p) => p.category_name == cat
						);
					}
				})
				.catch((err) => {
					console.error(err);
				});
		},

		/**
		 * Query our API to fetch all account manager
		 */
		getAllAccountManager() {
			this.$http
				.get(this.apiUrl + "users/all/accountmanager")
				.then((res) => {
					//console.log("getAllAccountManager");
					this.accountmanagerOptions = res.data.filter(
						(collaborator) => collaborator.status == 1
					);
				})
				.catch((err) => {
					console.error(err);
				});
		},

		getAllProducts() {
			this.$http
				.get(this.apiUrl + "product/all")
				.then((res) => {
					//console.log("getAllProducts", res.data);
					this.products = res.data;
				})
				.catch((err) => {
					console.error(err);
				});
		},

		getAllProductsCategories() {
			this.$http
				.get(this.apiUrl + "product/category/all")
				.then((res) => {
					//console.log("getAllProductsCategories", res.data);
					this.missionCategories = res.data.map((row) => row.name);
				})
				.catch((err) => {
					console.error(err);
				});
		},

		validateOne(val, name) {
			//if doc link

			//console.log(name + " " + val);
			let value = String(val);
			let constname = "";

			switch (name) {
				case "docLink":
					if (val == null || val == "") {
						//console.log("empty");
						constname = "Empty";
						break;
					} else {
						constname = "linkConstraint";
						break;
					}
				case "docName":
					if (this.docLink == null || this.docLink == "") {
						break;
					} else {
						constname = "nameConstraint";
						break;
					}

				case "product_id":
					constname = "isNumberConstraint";
					break;
				case "budget":
				case "billable_price":
					constname = "priceConstraint";
					break;
				default:
					constname = "nameConstraint";
					break;
			}

			this.validators[name] = new Validator({ constraintName: constname });
			this.validators[name].check(value);
			if (constname == "Empty") {
			} else {
				if (!value) {
					this.validators[name].errText = "Ce champ ne peut être vide.";
					this.validators[name].valid = false;
					this.$forceUpdate();
					return;
				}
			}

			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return "border: 1px solid red !important; border-radius: 5px;";
			} else if (this.validators[name] && this.validators[name].errText == "") {
				return "border: 1px solid green !important; border-radius: 5px;";
			}
		},

		/**
		 * Send the data to tha API to create the new user
		 * If the form is successfully sent, the user is redirect to Client.vue
		 */
		async formSubmitted() {
			this.check = true;
			let text = "Veuillez remplir tous les champs correctement.";
			let fields = [
				"product_id",
				"budget",
				"billable_price",
				"period",
				"docLink",
				"docName",
			];
			for (let i = 0; i < fields.length; i++) {
				let name;
				let value;
				if (fields[i] == "docLink") {
					value = this.docLink;
				} else if (fields[i] == "docName") {
					value = this.docName;
				} else {
					value = this.order[fields[i]];
					value === 0 ? (value = "0") : "";
				}

				switch (fields[i]) {
					case "docLink":
						value ? (value = String(value)) : "";
						if (value == null || value == "") {
							//console.log("empty");
							name = "Empty";
							break;
						} else {
							name = "linkConstraint";
							break;
						}
					case "docName":
						value ? (value = String(value)) : "";
						if (this.docLink == null || this.docLink == "") {
							name = "Empty";
							break;
						} else {
							name = "nameConstraint";
							break;
						}

					case "product_id":
						value ? (value = String(value)) : "";
						name = "isNumberConstraint";
						break;
					case "budget":
					case "billable_price":
						value == null ? "" : (value = String(value));
						name = "priceConstraint";
						break;
					default:
						name = "nameConstraint";
				}
				if (name == "Empty") {
					value = true;
				} else {
					this.validators[fields[i]] = new Validator({ constraintName: name });
					this.validators[fields[i]].check(value);
				}
				if (!value) {
					this.validators[fields[i]].valid = false;
					this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
					this.validators[fields[i]].notValid = true;
					this.validators[fields[i]].validText = "";
					if (this.order.billable == 0 && fields[i] == "billable_price") {
					} else this.check = false;
				}
			}

			if (this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: text,
				});
				this.$forceUpdate();
				return false;
			} else {
				//console.log("this.order", this.order);
				//console.log("document Link , ", this.docLink);
				let documentHeader = null;
				if (this.docLink == "" || this.docLink == null) {
				} else {
					//console.log("here in hader");
					documentHeader = {
						link: this.docLink,
						society_id: this.$props.contract.society_id,
						filename: this.docName,
						document_type_id: this.docType,
					};
				}
				// The complete line in context should be:
				this.$http
					.post(this.apiUrl + "orders/add", {
						order: {
							contract_id: this.contract.id || this.contract.contract_id,
							product_id: this.order.product_id,
							brief_text: this.order.brief_text,
							billable: this.order.billable,
							billable_price:
								this.order.billable == 1 ? this.order.billable_price : 0,
							budget: Number(
								String(this.order.budget || "0").replace(",", ".")
							), // Fixed line
							period: this.order.period,
							account_manager_id: this.order.account_manager_id,
							status: 1,
							user_id: this.activeUser.id,
							order_date: null,
							language: this.order.language,
							num_words: this.order.num_words,
							difficulty: this.order.difficulty,
						},
						document_link: documentHeader,
					})
					.then((res) => {
						if (res) {
							this.$vs.notify({
								title: "Succes",
								text: "La commande a bien été enregistrée.",
							});

							this.$emit("close-form-after-added", 1);
							this.closeForm();
						} else {
							this.$vs.notify({
								title: "Echec",
								text: "La commande n'a pas été enregistrée.",
							});
						}
					})
					.catch((err) => {
						console.error(err);
					});
			}
		},

		/**
		 * Closes the form
		 */
		closeForm() {
			//console.log("closeForm");
			this.$emit("close-form", false);
			this.showPopup = false;
			if (this.$props.isFromPopup) {
				this.$emit("close-popup", false);
			}
		},
	},
};
</script>

<style>
.role_selector_container {
	justify-content: space-between;
	width: 40%;
}
.small-field {
	padding-right: 10px;
	width: 100%;
}
.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}

.bottom {
	align-self: flex-end;
}

.center {
	align-self: center;
}

.inlineB {
	width: calc(100% - 30px) !important;
}

#select-control-width > .input-select-con {
	width: 100% !important;
}
</style>
